import { Button, styled, Typography } from "@mui/material";
import React from "react";

export function PrimaryButton(props) {
  return (
    <GradientButtonPrimary
      variant="contained"
      className="primaryGradientBg"
      fullWidth
      size="large"
      sx={{
        width: props.width && props.width,
        marginTop: props.mt && props.mt,
        marginBottom: props.mb && props.mb,
      }}
      {...props}
    >
      <ButtonLabel variant="button" className="primaryGradientBgLabel">
        {props?.displayVal ? props?.displayVal : "Continue"}
        {/* Continue */}
        {/* {props?.displayVal ?? "Continue"} */}
      </ButtonLabel>
    </GradientButtonPrimary>
  );
}

const GradientButtonPrimary = styled(Button)(() => ({
  textTransform: "uppercase",
  borderRadius: "12px",
  padding: "0px",
  // background: "linear-gradient(93.13deg, #5E70CC 29.23%, #D9416C 132.75%)",
  // height: "62px",
  background: "#a6ce39",
  marginTop: "16px",
  marginBottom: "16px",
  boxShadow: "0px 3px 6px rgb(0 0 0 / 8%)",
  "&.Mui-disabled": {
    background: "#bec6eb",
    boxShadow: "0px 3px 6px rgb(0 0 0 / 8%)",
  },
}));

const ButtonLabel = styled(Typography)(() => ({
  textTransform: "uppercase",
  color: "#ffffff",
  fontSize: "18px",
  fontWeight: "600",
  textTransform: "capitalize",
  // paddingTop: "5px",
  // paddingBottom: "5px",
}));
